/* global angular, swal, _ */
export default function($scope, $log, $q, $stateParams, $timeout, ApiClass, $uibModalInstance, selectedEmployees) {
  'ngInject';
  $scope.resultsQueried = false;
  ApiClass.activitiesGet(
    { manage: true, profile_uid: 'a uid' },
    {},
    {
      queryParams: {
        filters: JSON.stringify({
          basic: true
        }),
        includes: JSON.stringify({
          profiles: false,
          progress: false
        })
      }
    }
  )
    .then(activitiesResponse => {
      const activities = activitiesResponse.data.items;
      $scope.allActivities = [];
      $scope.assigned = [];
      $scope.alreadyStarted = [];
      $scope.resultsQueried = true;
      $scope.allActivities = activities.filter(activity => {
        return true;
      });
    })
    .catch(error => {
      $log.error(error);
      throw error;
    });
  $scope.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.assignEmployeesActivity = activities => {
    const selectedActivities = activities.filter(({ selected }) => selected);
    const profile_uids = selectedEmployees.map(({ profile_uid }) => profile_uid);

    if (!selectedActivities.length) {
      $scope.cancel();
      swal('Error', 'Select one or more activities', 'error');
      return;
    }

    return Promise.all(
      selectedActivities.map(activity =>
        ApiClass.activitiesIdTypePut(
          { id: activity.uuid, type: 'assigned' },
          { profile_uids },
          { queryParams: { manage: true } }
        )
      )
    )
      .then(data => {
        swal('Assigned', 'Activity(s) assigned', 'success');
        $uibModalInstance.close();
      })
      .catch(error => {
        $log.error(error);
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/modals/employeesActivities/index.js